// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3TuCb","tab":"Tabs_tab__3vaRb","tabActive":"Tabs_tabActive__2n_3A"};